import {
  Icon,
  IconAlertTriangle,
  IconCheck,
  IconCircleDashed,
  IconMessage,
  IconPhotoCheck,
  IconPhotoOff,
  IconProgress,
} from '@tabler/icons-react';

import {
  HarvestProofFormStatus,
  HarvestProofParcelStatus,
} from '@harvest-proof/data-access';

export type HarvestProofStatusBadgeVariant = 'form' | 'parcel';

type StatusConfig = {
  icon: Icon;
  color: string;
  labelKey: string;
  tooltipKey: string;
};

export const HARVEST_PROOF_FORM_STATUS_CONFIG: Record<
  HarvestProofFormStatus,
  StatusConfig
> = {
  [HarvestProofFormStatus.NOT_STARTED]: {
    icon: IconCircleDashed,
    color: 'gray',
    labelKey: 'harvest-proof.formStatus.NOT_STARTED.label',
    tooltipKey: 'harvest-proof.formStatus.NOT_STARTED.tooltip',
  },
  [HarvestProofFormStatus.SMS_SENT]: {
    icon: IconMessage,
    color: 'yellow',
    labelKey: 'harvest-proof.formStatus.SMS_SENT.label',
    tooltipKey: 'harvest-proof.formStatus.SMS_SENT.tooltip',
  },
  [HarvestProofFormStatus.IN_PROGRESS]: {
    icon: IconProgress,
    color: 'blue',
    labelKey: 'harvest-proof.formStatus.IN_PROGRESS.label',
    tooltipKey: 'harvest-proof.formStatus.IN_PROGRESS.tooltip',
  },
  [HarvestProofFormStatus.COMPLETE]: {
    icon: IconCheck,
    color: 'pf-green',
    labelKey: 'harvest-proof.formStatus.COMPLETE.label',
    tooltipKey: 'harvest-proof.formStatus.COMPLETE.tooltip',
  },
  [HarvestProofFormStatus.SMS_FAILED]: {
    icon: IconAlertTriangle,
    color: 'red',
    labelKey: 'harvest-proof.formStatus.SMS_FAILED.label',
    tooltipKey: 'harvest-proof.formStatus.SMS_FAILED.tooltip',
  },
};

export const HARVEST_PROOF_PARCEL_STATUS_CONFIG: Record<
  HarvestProofParcelStatus,
  StatusConfig
> = {
  [HarvestProofParcelStatus.PROOF_MISSING]: {
    icon: IconPhotoOff,
    color: 'orange',
    labelKey: 'harvest-proof.parcelStatus.PROOF_MISSING.label',
    tooltipKey: 'harvest-proof.parcelStatus.PROOF_MISSING.tooltip',
  },
  [HarvestProofParcelStatus.PROOF_RECEIVED]: {
    icon: IconPhotoCheck,
    color: 'pf-green',
    labelKey: 'harvest-proof.parcelStatus.PROOF_RECEIVED.label',
    tooltipKey: 'harvest-proof.parcelStatus.PROOF_RECEIVED.tooltip',
  },
};

export function getHarvestProofStatusConfig(
  status: HarvestProofFormStatus | HarvestProofParcelStatus,
  variant: HarvestProofStatusBadgeVariant,
) {
  if (variant === 'parcel') {
    return HARVEST_PROOF_PARCEL_STATUS_CONFIG[
      status as HarvestProofParcelStatus
    ];
  }

  return HARVEST_PROOF_FORM_STATUS_CONFIG[status as HarvestProofFormStatus];
}
